import dayjs from 'dayjs'

export default function getMaxFetchDate() {
  return dayjs()
    .add(6, 'months')
    .format('DD/MM/YYYY')
}
